import * as React from 'react'

import { OverlayTrigger, Popover } from 'react-bootstrap'

interface InfoPopupProps {
	title: string
	id?: string
	className?: string
	style?: React.CSSProperties
	placement?: 'top' | 'right' | 'bottom' | 'left'
	element?: React.ReactNode
	trigger?: string[]
}
export const InfoPopup: React.SFC<InfoPopupProps> = (props) => (
	<OverlayTrigger
		trigger={props.trigger || ['hover', 'focus']}
		rootClose
		placement={props.placement ? props.placement : 'right'}
		overlay={
			<Popover title={props.title} id={props.id || props.title}>
				{props.children}
			</Popover>
		}
	>
		{props.element || <i className={'fa fa-info-circle ' + props.className || ''} style={props.style} />}
	</OverlayTrigger>
)
